import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { NumericFormat } from 'react-number-format';
import { deepEqual } from "../../../utils/object";

class Name extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default ?? 0,
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }

    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? 0;
        if (deepEqual(this.state.data, newData)) return;
        this.setState({
            data: newData
        });
    }
    
    onChange = (values) => {
        const newValue = values.value; // Get the raw numeric value
        if (this.state.data === newValue) return;

        this.setState({
            data: newValue
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    render() {
        return (<>
            <Row className="g-3">
                <Col>
                    <div className="mb-3 top-label">
                        <NumericFormat
                            customInput={Form.Control}
                            value={this.state.data || 0}
                            onValueChange={this.onChange}
                            thousandSeparator=","
                            prefix="$"
                            decimalScale={2}
                            fixedDecimalScale={true}
                            allowNegative={false}
                            placeholder="$0.00"
                            name={this.props.element}
                            readOnly={this.state.locked}
                        />
                        <Form.Label>{this.state.label}</Form.Label>
                    </div>
                </Col>
            </Row>
        </>)
    }
}

export default Name;